"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CopyButton;
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AuButton = _interopRequireWildcard(require("./AuButton"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "copy_button": "copy_button-module__copy_button___Gwf_P"
};
function CopyButton({
  className,
  data,
  shouldDisable
}) {
  const [hasUserCopied, setHasUserCopied] = _react.default.useState(false);
  function onCopy() {
    navigator.clipboard.writeText((0, _stringify.default)(data)).then(() => {
      setHasUserCopied(true);
      (0, _setTimeout2.default)(() => {
        setHasUserCopied(false);
      }, 3000);
    });
  }
  return /*#__PURE__*/_react.default.createElement(_AuButton.default, {
    className: (0, _classnames.default)(styles.copy_button, className),
    displayId: hasUserCopied ? "au.jsonBox.copied" : "au.jsonBox.copyClipboard",
    type: _AuButton.BUTTON_TYPE_TERTIARY,
    size: _AuButton.BUTTON_SIZE_MEDIUM,
    disabled: shouldDisable || hasUserCopied,
    onClick: onCopy
  });
}